Vue.component('ack-product-showcase-title', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-product-showcase-title',
	mounted() {
		appLog.log('ack-product-showcase-title mounted');
	},
	props: {
		productInfo: {
			// :product-info
			type: Object,
			required: true,
		},
		isMobile: {
			type: Boolean,
			required: true,
		},
		shopProductInfo: {
			type: Object,
			required: false,
		},
		bundleTag: {
			type: String,
			default: 'shop-3dps-4',
		},
		bundleTitle: {
			type: String,
			default: 'Purchase Now on Our Website',
		},
	},
	computed: {
		//...Vuex.mapGetters('navBar', ['switchMobileDropdowns']),
		...Vuex.mapGetters('localization', [
			'countryCode',
			'isUS_CA',
			'redirectLinkWhenHideStore',
			'isAU_NZ',
		]), //isStoreAvailable
		...Vuex.mapGetters('shop', ['isStoreAvailable']),
		priceLabel() {
			return `${this.productInfo.currencyCode} ${this.productInfo.price}`;
		},
	},
	data() {
		return {};
	},
	methods: {
		//...Vuex.mapActions(['sayHi', 'someAction']),
		//...Vuex.mapActions('navBar', ['sayHi', 'closeAllMobileDropdowns']),
	},
	beforeDestroy() {},
	watch: {
		data: {
			handler() {},
			deep: false,
		},
	},
});
